import {
  DEFAULT_BLACK_IMAGE_PATH
} from '../../scripts/Routes/images.js';

/**
 * Songs I'd like to learn how to play
 * - Passionfruit
 * 
 * Seven minute set
 * - Better Together
 * - Why Georgia
 * - Blackbird
 */

export const guitarSetList2018 = [
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Better Together - Jack Johnson',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Why Georgia - John Mayer',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Razor - Foo Fighters',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Belief - John Mayer',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Wonderland - John Mayer',
        'url': '#',
    },
];

export const guitarSetList2019 = [
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Why Georgia by John Mayer',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Better Together by Jack Johnson',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Eastside by Khalid',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Love Yourself - Justin Bieber',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Crash Into Me - Dave Matthews Band',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Blackbird by The Beatles',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Stop this Train by John Mayer',
        'url': '#',
    },
];

export const guitarSetList2020 = [
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Passionfruit',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Stop This Train',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Heart of Life',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Edge of Desire',
        'url': '#',
    },
];
